export enum PhotoStatus {
    READY_FOR_UPLOAD = 1,
    UPLOADED = 2,
    FAILED = 3,
}
